import { render, staticRenderFns } from "./ProtocolTable.vue?vue&type=template&id=62d7e351&scoped=true"
import script from "./ProtocolTable.vue?vue&type=script&lang=js"
export * from "./ProtocolTable.vue?vue&type=script&lang=js"
import style0 from "./ProtocolTable.vue?vue&type=style&index=0&id=62d7e351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d7e351",
  null
  
)

export default component.exports